import React, {useEffect, useState} from 'react'
import {ChevronDownIcon, ChevronRightIcon, TrashIcon} from "@heroicons/react/24/solid";
import _ from 'lodash'
import ShowDesignVariantStatus from "../common/show-design-variant-status";
import ShowParentProductColorList from "../common/show-parent-product-color-list";
import ShowProductColorTags from "../common/show-product-color-tags";

const SelectedParentProductsList = ({
                                        selectedParentProductList,
                                        selectedParentProduct,
                                        setSelectedParentProduct
                                    }) => {

    return (
        <>

            <div
                className="overflow-y-scroll form-container select-images-table-container">
                <div className="px-2">
                    {selectedParentProductList?.map((parentProduct, index) => (
                        <React.Fragment key={index}>
                            <div onClick={() => {
                                setSelectedParentProduct(parentProduct);
                            }}
                                 className={`flex justify-between my-2 cursor-pointer rounded border ${selectedParentProduct?.id === parentProduct?.id ? 'bg-purple-100 text-purple-700 shadow-xl border-4 border-purple-600' : 'border-gray-400 bg-white'}`}>

                                <div className="p-4 align-middle flex justify-between w-full">
                                    <div className="flex justify-start w-full">
                                        <div
                                            className="font-semibold mr-2">#{index + 1}</div>

                                        <div className="w-full">
                                            <div
                                                className="align-middle">{parentProduct?.name}</div>

                                            {/*<div className="flex justify-between w-full mt-2">
                                                <div className="mt-2">
                                                    {parentProduct?.colors?.length > 0 &&
                                                        <ShowProductColorTags parent={parentProduct}/>
                                                    }

                                                    {!parentProduct?.colors &&
                                                        <div className="text-red-400 font-semibold ml-1">No Product
                                                            Colors</div>
                                                    }
                                                </div>
                                            </div>*/}

                                            <div className="align-middle mt-2 font-bold text-gray-500">
                                                {parentProduct?.productType} / {parentProduct?.category}
                                            </div>

                                            <div className="align-middle">
                                                {parentProduct?.widthInch}" x {parentProduct?.heightInch}" (WxH)
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>

        </>
    )
}

export default SelectedParentProductsList
